module.exports = __webpack_public_path__ + "static/media/YF40_2.dca4b09c.jpg";